import { PossibleAnswerDto } from 'api/survey';
import clsx from 'clsx';
import { CheckIcon } from 'components/icons/Icons';
import { FC } from 'react';
import { QuickSurveyAnswerCardsProps } from './quickSurvey.types';

export const QuickSurveyAnswerCards: FC<QuickSurveyAnswerCardsProps> = ({
  answers,
  selectedAnswerId,
  onSelect
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {answers.map((answer) => {
        const isSelected = answer.id === selectedAnswerId;
        return (
          <button
            key={answer.id}
            type="button"
            onClick={() => onSelect(answer)}
            className={clsx(
              'relative px-4 py-2 rounded-lg border-2 text-sm font-medium transition-all duration-200',
              'focus:outline-none focus:ring-2 focus:ring-primary/50 focus:ring-offset-1',
              isSelected
                ? 'border-primary bg-primary/10 text-primary'
                : 'border-gray-200 bg-white text-gray-700 hover:border-primary/40 hover:bg-gray-50'
            )}
          >
            <span className="flex items-center gap-2">
              {isSelected && (
                <CheckIcon className="w-4 h-4 text-primary flex-shrink-0" />
              )}
              {answer.label}
            </span>
          </button>
        );
      })}
    </div>
  );
};
